// extracted by mini-css-extract-plugin
module.exports = {"filterBox":"Filters_filterBox__3mT-r","btn":"Filters_btn__1NkbO"};